import { render } from "./DeployVnfAppliance.vue?vue&type=template&id=1b64e767&scoped=true"
import script from "./DeployVnfAppliance.vue?vue&type=script&lang=js"
export * from "./DeployVnfAppliance.vue?vue&type=script&lang=js"

import "./DeployVnfAppliance.vue?vue&type=style&index=0&id=1b64e767&lang=less&scoped=true"
import "./DeployVnfAppliance.vue?vue&type=style&index=1&id=1b64e767&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b64e767"]])

export default __exports__